// extracted by mini-css-extract-plugin
module.exports = {"modal":"OpvModal_modal__2Wuuw","header":"OpvModal_header__3pDW2","wrapper":"OpvModal_wrapper__2Fmr_","title":"OpvModal_title__36gbJ","footer":"OpvModal_footer__n7R0X"};